import { Type } from './action-types';
import { entireAudioEnhancer } from './enhancers';
import { stateFactory } from './factories';
import { EpisodeWizardAction, EpisodeWizardState } from './types';

function reducer(state: EpisodeWizardState, action: EpisodeWizardAction) {
  switch (action.type) {
    case Type.EPISODE_WIZARD_CLEAR:
      return stateFactory();

    default:
      return state;
  }
}

export default entireAudioEnhancer.createReducer(reducer, stateFactory());
